export const GooglePayPreview = ({getData}) => {
    const buttonType = getData('buttonStyle').buttonType;
    const src = getData('editorIcons').long;
    return (
        <div
            className={`gpay-block-editor ${buttonType}`}
            style={{maxHeight: '40px', backgroundColor: '#000', borderRadius: '4px'}}>
            <img
                src={src}
                style={{
                    width: '100%',
                    height: '40px',
                    objectFit: 'contain'
                }}/>
        </div>
    )
}